import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { registerBusinessHost, type BusinessHost } from './host'
import { businessModals } from './modals'

const Create = lazy(() => import('./components/Create'))
const DetailBusiness = lazy(() =>
    import('./components/Detail').then((m) => ({ default: m.DetailBusiness }))
)
const List = lazy(() => import('./components/List'))

const BusinessModule: RouteObject = {
    path: 'account/businesses',
    children: [
        {
            path: '',
            element: <List pageType="member" />,
        },
        {
            path: 'new',
            element: <Create />,
        },
        {
            path: ':businessID',
            element: <DetailBusiness />,
        },
    ],
}

const HRMBusinessModule: RouteObject = {
    path: '/businesses',
    children: [
        {
            path: '',
            element: <List pageType="hrm" />,
        },
    ],
}

/**
 * The Business routes, for the host to mount (it adds the errorElement).
 *
 * This is the only way to get them, and it takes the host: so a host cannot
 * mount the routes and forget to register the pieces they read at render time.
 * Registering also adds the `business` i18n namespace and the module's modals.
 */
export function createBusinessModule(host: BusinessHost): RouteObject[] {
    registerBusinessHost(host)
    host.registerModals(businessModals)
    return [BusinessModule, HRMBusinessModule]
}

export type { BusinessHost } from './host'
